import { dismissNotifications } from '../../../hooks/useNotification';
import FEATURES from '../features';
const Actions = self => ({
    load: user => {
        try {
            dismissNotifications();
            self.setUser(user);
            self.isLoaded = true;
        }
        catch (e) {
            self.id = undefined;
        }
    },
    setUser: user => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        self.id = user.id;
        self.accountId = user.accountId;
        self.firstName = user.firstName;
        self.lastName = user.lastName;
        self.countryCode = (_a = user.countryCode) !== null && _a !== void 0 ? _a : undefined;
        self.email = user.email;
        self.phone = (_b = user.phone) === null || _b === void 0 ? void 0 : _b.toString();
        self.hashedEmail = user.hashedEmail;
        self.industry = user.industry;
        self.isAccountAdmin = Boolean(user.admin);
        self.accountDomain = user.domain;
        self.groupName = (_c = user.group) === null || _c === void 0 ? void 0 : _c.name;
        self.features = user.features ? [...user.features] : [];
        self.isSearchByDataPointEnabled =
            (user.features || []).includes(FEATURES.SHOW_SPECIFIC_DATA_POINTS) &&
                !(user.features || []).includes(FEATURES.SCALE_FREE_TRIAL);
        self.isOneWalletEnabled = (user.features || []).includes(FEATURES.ONE_WALLET);
        self.priceBook = (_e = (_d = user.accountBillingPlans) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.priceBook;
        self.accountUnfreezeDate = ((_g = (_f = user.accountBillingPlans) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.endDate) || '';
        self.roleId = (_h = user === null || user === void 0 ? void 0 : user.role) === null || _h === void 0 ? void 0 : _h.id;
        self.subscriptionStatus = ((_k = (_j = user.accountBillingPlans) === null || _j === void 0 ? void 0 : _j[0]) === null || _k === void 0 ? void 0 : _k.subscriptionStatus) || '';
        if (user === null || user === void 0 ? void 0 : user.account) {
            self.accountStatus = user.account.status || 'active';
            self.accountStatusReason = user.account.statusReason || '';
        }
        self.setBillingInfo(user.billing, user.accountBillingPlans);
        self.analytics.setInfo(user.analytics);
    },
    setBillingInfo: (billing, accountBillingPlans) => {
        var _a, _b, _c, _d;
        if (!billing) {
            return;
        }
        const { category, isPaid, endDate, renewalType, renews = true } = billing;
        const stripeInvoiceLink = (_a = accountBillingPlans === null || accountBillingPlans === void 0 ? void 0 : accountBillingPlans[0]) === null || _a === void 0 ? void 0 : _a.stripeInvoiceLink;
        const stripePaymentMethodCountryCode = (_b = accountBillingPlans === null || accountBillingPlans === void 0 ? void 0 : accountBillingPlans[0]) === null || _b === void 0 ? void 0 : _b.stripePaymentMethodCountryCode;
        const billingPlanId = (_c = accountBillingPlans === null || accountBillingPlans === void 0 ? void 0 : accountBillingPlans[0]) === null || _c === void 0 ? void 0 : _c.billingPlanId;
        const startDate = (_d = accountBillingPlans === null || accountBillingPlans === void 0 ? void 0 : accountBillingPlans[0]) === null || _d === void 0 ? void 0 : _d.startDate;
        self.billing = {
            category,
            isPaid,
            endDate: new Date(endDate),
            stripeInvoiceLink,
            stripePaymentMethodCountryCode,
            renewalType,
            billingPlanId,
            renews,
            startDate: new Date(startDate),
        };
    },
    onCreditUsed: () => {
        --self.availableCredits;
    },
    setBulkAvailableCredits(value) {
        self.bulkAvailableCredits = value !== null && value !== void 0 ? value : 0;
    },
});
export default Actions;
